import {h, Fragment} from "preact"
import { defaultConfig } from '../config'
import { useEffect } from 'preact/hooks'

export default () => {

    useEffect(() => {
        window.nostojs(function(api) {
            api.loadRecommendations();
        });
    }, [])

    return (
        <div class="ns-autocomplete">
            <div class="ns-autocomplete-body">
                <div class="nosto_element" id="searchterms-nosto-1"></div>
                <div class="nosto_element" id="searchdropdown-nosto-1"></div>
            </div>
        </div>
    )
}
